export default {
  submitText: '保存',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      disabled: true,
      editDisabled: true,
      search: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
    },
    {
      label: '车主名称',
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入车主名称',
          trigger: 'change',
        },
      ],
    },
    {
      label: '手机号',
      prop: 'customerPhone',
      search: true,
      disabled: true,
      rules: [
        { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
        {
          trigger: 'blur',
          min: 11,
          max: 11,
          message: '请输入11位手机号',
        },
      ],
    },
    {
      label: '区域',
      prop: 'regions',
      hide: true,
      type: 'tree',
      multiple: true,
      checkStrictly: true,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择通行区域',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费标准',
      prop: 'ruleId',
      type: 'tree',
      dicData: [],
      props: {
        label: 'remark',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择收费标准',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '开始时间',
      prop: 'buyStartTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '套餐周期',
      prop: 'cycleNum',
      disabled: false,
      viewDisplay: false,
      hide: true,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      rules: [
        {
          required: true,
          message: '请选择续租时长',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '结束时间',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      disabled: true,
    },
    {
      label: '应收金额',
      prop: 'shouldMoney',
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入应收金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '收款单号',
      prop: 'payId',
      hide: true,
      display: false,
      rules: [
        {
          required: true,
          message: '请输入收款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款单号',
      display: false,
      hide: true,
      prop: 'returnId',
      rules: [
        {
          required: true,
          message: '请输入退款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费标识',
      prop: 'returnFlag',
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费标识 0.未退费 1.已退费',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费金额',
      prop: 'returnMoney',
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '小区名称',
      prop: 'communityName',
      type: 'input',
      display:false,
      disabled: true,
    },
    {
      label: '楼栋',
      prop: 'buildingId',
      type: 'input',
      display:false,
      disabled: false,
      formslot: true,
    },
    {
      label: '房间',
      prop: 'roomId',
      type: 'input',
      disabled: true,
      readonly:true,
      formslot: true,
    },
    {
      label: '停车位',
      prop: 'lotNo',
      rules: [
        {
          required: false,
          message: '请输入停车位编号',
          trigger: 'change',
        },
      ],
    },
  ],
};
